'use strict';
import angular from 'angular';
import PaymentCreditCardController from './payment-credit-card.controller';
import CreditCardService from '../credit-card-list/credit-card.service';
import CartService from '../../app/cart/cart.service';
import AddressForm from '../forms/account/address';
import AddressService from '../forms/account/address/address.service';
import giftCardBalance from '../giftCardBalance';
export default angular.module('directives.paymentCreditCardForm', [
    AddressForm, giftCardBalance,
    'tooltip'
])
    .service('CreditCardService', CreditCardService)
    .service('CartService', CartService)
    .service('AddressService', AddressService)
    .controller('PaymentCreditCardController', PaymentCreditCardController)
    .component('paymentCreditCardForm', {
    template: require('./payment-credit-card.html'),
    bindings: {
        onSelectPayment: '&',
        onFormValidate: '&'
    },
    controller: PaymentCreditCardController
})
    .name;
//# sourceMappingURL=index.js.map